/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PccPatientResponseLanguageInner } from './PccPatientResponseLanguageInner';
import {
    PccPatientResponseLanguageInnerFromJSON,
    PccPatientResponseLanguageInnerFromJSONTyped,
    PccPatientResponseLanguageInnerToJSON,
    PccPatientResponseLanguageInnerToJSONTyped,
} from './PccPatientResponseLanguageInner';
import type { PccPatientResponseRaceInner } from './PccPatientResponseRaceInner';
import {
    PccPatientResponseRaceInnerFromJSON,
    PccPatientResponseRaceInnerFromJSONTyped,
    PccPatientResponseRaceInnerToJSON,
    PccPatientResponseRaceInnerToJSONTyped,
} from './PccPatientResponseRaceInner';
import type { PccPatientAddress } from './PccPatientAddress';
import {
    PccPatientAddressFromJSON,
    PccPatientAddressFromJSONTyped,
    PccPatientAddressToJSON,
    PccPatientAddressToJSONTyped,
} from './PccPatientAddress';

/**
 * 
 * @export
 * @interface PccPatientResponse
 */
export interface PccPatientResponse {
    /**
     * 
     */
    orgUuid?: string;
    /**
     * 
     */
    facId?: number;
    /**
     * 
     */
    patientId?: number;
    /**
     * 
     */
    patientStatus?: number;
    /**
     * 
     */
    firstName?: string;
    /**
     * 
     */
    lastName?: string;
    /**
     * 
     */
    middleName?: string;
    /**
     * 
     */
    gender?: string;
    /**
     * 
     */
    birthDate?: string;
    /**
     * 
     */
    prefix?: string;
    /**
     * 
     */
    suffix?: string;
    /**
     * 
     */
    homePhone?: string;
    /**
     * 
     */
    cellPhone?: string;
    /**
     * 
     */
    language?: Array<PccPatientResponseLanguageInner>;
    /**
     * 
     */
    maritalStatus?: string;
    /**
     * 
     */
    race?: Array<PccPatientResponseRaceInner>;
    /**
     * 
     */
    previousAddress?: PccPatientAddress;
}

/**
 * Check if a given object implements the PccPatientResponse interface.
 */
export function instanceOfPccPatientResponse(value: object): value is PccPatientResponse {
    return true;
}

export function PccPatientResponseFromJSON(json: any): PccPatientResponse {
    return PccPatientResponseFromJSONTyped(json, false);
}

export function PccPatientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPatientResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'orgUuid': json['orgUuid'] == null ? undefined : json['orgUuid'],
        'facId': json['facId'] == null ? undefined : json['facId'],
        'patientId': json['patientId'] == null ? undefined : json['patientId'],
        'patientStatus': json['patientStatus'] == null ? undefined : json['patientStatus'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'birthDate': json['birthDate'] == null ? undefined : json['birthDate'],
        'prefix': json['prefix'] == null ? undefined : json['prefix'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'homePhone': json['homePhone'] == null ? undefined : json['homePhone'],
        'cellPhone': json['cellPhone'] == null ? undefined : json['cellPhone'],
        'language': json['language'] == null ? undefined : ((json['language'] as Array<any>).map(PccPatientResponseLanguageInnerFromJSON)),
        'maritalStatus': json['maritalStatus'] == null ? undefined : json['maritalStatus'],
        'race': json['race'] == null ? undefined : ((json['race'] as Array<any>).map(PccPatientResponseRaceInnerFromJSON)),
        'previousAddress': json['previousAddress'] == null ? undefined : PccPatientAddressFromJSON(json['previousAddress']),
    };
}

export function PccPatientResponseToJSON(json: any): PccPatientResponse {
    return PccPatientResponseToJSONTyped(json, false);
}

export function PccPatientResponseToJSONTyped(value?: PccPatientResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orgUuid': value['orgUuid'],
        'facId': value['facId'],
        'patientId': value['patientId'],
        'patientStatus': value['patientStatus'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'middleName': value['middleName'],
        'gender': value['gender'],
        'birthDate': value['birthDate'],
        'prefix': value['prefix'],
        'suffix': value['suffix'],
        'homePhone': value['homePhone'],
        'cellPhone': value['cellPhone'],
        'language': value['language'] == null ? undefined : ((value['language'] as Array<any>).map(PccPatientResponseLanguageInnerToJSON)),
        'maritalStatus': value['maritalStatus'],
        'race': value['race'] == null ? undefined : ((value['race'] as Array<any>).map(PccPatientResponseRaceInnerToJSON)),
        'previousAddress': PccPatientAddressToJSON(value['previousAddress']),
    };
}

